import React, { useRef } from "react";
import PropTypes from "prop-types";
// import TextField from '@material-ui/core/TextField';
import TextField from '@mui/material/TextField';
import { InputLabel, Paper, Tooltip } from "@mui/material";


const styles = {
    textField: {
        fontFamily: "Customfont !important"
    }
}


export default function CustomInput(props) {
    const { label, id, defaultValue, helperText, inputType, tabIndex, placeholder, readonly } = props


    const [state, setState] = React.useState({
        onChange: false,
        inputData: ""
    });
    React.useEffect(async () => {
        console.log("defaultValue", defaultValue)
        await setState(prevState => ({ ...prevState, inputData: defaultValue, onChange: false }))

        return () => {
        }
    }, [defaultValue])

    // React.useEffect(() => {
    //     try {
    //         if (state.onChange === true) {
    //           //  props.resData(state.inputData)
    //             setState(prevState => ({ ...prevState, onChange: false }))
    //         }
    //     } catch (error) {
    //         console.log("cate props input")
    //     }
    //     return () => {
    //     }
    // }, [state.inputData, state.onChange])

    const handleChange = (event) => {
        // event.preventDefault(); 
        //console.log("handleChange", event.target.value);
        setState(prevState => ({ ...prevState, inputData: event.target.value, onChange: true }))
        // try {
        //     props.resData(event.target.value)
        // } catch (error) {
        // }
    }
    const onBlur = (event) => {
        try {
            props.resData(event.target.value)
        } catch (error) {

        }

    }
    const handleKeyDown = (event) => {
        // event.preventDefault(); 
        try {
            //     if (event.key === "Enter") {
            props.keyDown(event.key)
        }
        catch (error) {
            console.log("keyDown ", error);
        }
    }
    return (
        <>

            <Paper
                elevation={0}
                component="div"
                sx={{
                    pl: '5px',
                    pt: '1px',
                    m: "0px",
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: "#eee",
                    border: "1px solid #ccc",
                    verticalAlign: "middle",

                }}

            >
                <Tooltip title={label}>
                    <InputLabel sx={{
                        width: "140px", whiteSpace: "nowrap",
                        fontSize: "16px",
                        fontFamily: "Customfont !important",
                        color: "black",
                        verticalAlign: "middle"
                    }}  >{label}</InputLabel>
                </Tooltip>

                <TextField
                    sx={{
                        //     "& label.Mui-focused": {
                        //         display: "none",
                        //     },
                        //     "& legend": {
                        //         display: "none",
                        //     },
                        backgroundColor: "#fff",
                        fontFamily: "Customfont"
                        //     marginTop: "0px",
                    }}
                    hiddenLabel
                    id={id}
                    // defaultValue={defaultValue}
                    onChange={handleChange}
                    value={state.inputData}
                    helperText={helperText}
                    variant="standard"
                    size="small"
                    type={inputType}
                    fullWidth
                    tabIndex={tabIndex}
                    placeholder={placeholder}
                    onBlur={e => onBlur(e)}
                    onKeyDown={handleKeyDown}
                    disabled={readonly}
                    inputProps={{ style: { fontSize: "0.9rem", fontFamily: "Customfont" } }}

                />
            </Paper>
        </>
    );
}
CustomInput.propTypes = {
    label: PropTypes.string,
    id: PropTypes.string,
    defaultValue: PropTypes.string,
    helperText: PropTypes.string,
    inputType: PropTypes.oneOf(["button", "checkbox", "color", "date", "datetime-local", "email", "file", "hidden", "image", "month", "number", "email", "password", "radio", "range", "reset", "search", "submit", "tel", "text", "time-local", "url", "file", "week"]),
    placeholder: PropTypes.string,
    tabIndex: PropTypes.string,
    readonly: PropTypes.bool
}
CustomInput.defaultValue = {
    readonly: false
}
